module.exports = __webpack_public_path__ + "static/media/22-1.cb2b3b79.mp3";